import React from 'react';
import Framework from "@beardeddevops/react.framework";
import {Collections, Parts} from "components";
import UserRoles from "constants/UserRoles";

const breadcrumbsStatic = [{
	name: '7 Day Missing Financials',
	url: '/helpdesks/missing',
	icon: 'comments'
}];

class HelpDesks7DayMissing extends Framework.Components.View {
	constructor(props) {
		super(props);
		this.state.activeHelpdeskData = [];
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		const activeHelpdeskData = localStorage.getItem('activeHelpdesks') ? JSON.parse(localStorage.getItem('activeHelpdesks')) : [];
		if (JSON.stringify(activeHelpdeskData) !== JSON.stringify(prevState.activeHelpdeskData)) {
			this.setState({activeHelpdeskData})
		}
	}

	render() {
		let {history, roles} = this.props;
		const {activeHelpdeskData} = this.state;
		return (
			<div className={'container-fluid'}>
				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history}/>

				<Parts.Tickers.HelpdeskTicker/>
				<Collections.HelpDesks7DayMissing
					history={history}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					showCSV={roles.includes(UserRoles.Admin)}
					roles={roles}
				/>
			</div>

		)
	}
}

export default Framework.Components.withRootState(HelpDesks7DayMissing);